document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.getElementById('CartDrawer');
    const cartOverlay = document.getElementById('CartDrawer-Overlay');
    const cartIcon = document.getElementById('cart-icon-bubble');
    const cartErrors = document.getElementById('CartDrawer-CartErrors');
    const emptyContent = document.getElementsByClassName('drawer__inner-empty');
    const drawerWrapper = document.getElementById('CartDrawer-Content');
    const cartCheckoutBtn = document.getElementById('CartDrawer-Checkout');

    /**
   * Opens the cart drawer.
   */
    const openCartDrawer = async () => {
        cartDrawer.querySelector('#loading-overlay').classList.remove('hide-important');
        cartDrawer.classList.add('active');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
        cartCheckoutBtn.setAttribute('disabled', 'disabled');
        await setupDrawer();
        cartDrawer.querySelector('#loading-overlay').classList.add('hide-important');
    }

    /**
     * Get minimum checkout amount with fallbacks
     * @returns {number} The minimum checkout amount
     */
    const getMinCheckoutAmount = () => {
        // Primary: Get from window global
        if (typeof window.min_checkout_amount !== 'undefined' && window.min_checkout_amount !== null) {
            return window.min_checkout_amount;
        }
        
        // Fallback 1: Try to get from theme.liquid data attribute
        const bodyElement = document.body;
        if (bodyElement && bodyElement.dataset.minCheckoutAmount) {
            const fallbackAmount = parseFloat(bodyElement.dataset.minCheckoutAmount) / 100;
            return fallbackAmount;
        }
        
        // Fallback 2: Get from settings (hardcoded known value)
        const hardcodedMinimum = 40; // £40 as mentioned in the issue
        /* console.log('⚠️ [CartDrawer] Using hardcoded fallback minimum:', hardcodedMinimum); */
        return hardcodedMinimum;
    }

    /**
     * Check if the customer is in the staff segment (has 'staff' tag).
     * @returns {boolean} True if customer has the staff tag, false otherwise.
     */
    const isCustomerInStaffSegment = () => {
        if (typeof window.customerData !== 'undefined' && window.customerData && window.customerData.tags) {
            const customerTags = Array.isArray(window.customerData.tags)
                ? window.customerData.tags
                : String(window.customerData.tags).split(',');
            const normalizedTags = customerTags.map((tag) => String(tag).trim().toLowerCase());
            const isStaff = normalizedTags.includes('staff');
            return isStaff;
        }
        return false;
    }

    /**
     * Set Checkout button based on the cart total.
     * @param {number} cartTotal - The total price of the cart.
     */
    const setCheckoutButton = (cartTotal) => {
        const configuredMinCheckoutAmount = getMinCheckoutAmount();
        const cartTotalInPounds = parseFloat(cartTotal/100).toFixed(2);
        const isStaffMember = isCustomerInStaffSegment();
        const minCheckoutAmount = isStaffMember ? 0 : configuredMinCheckoutAmount;
        
        const meetsMinimum = cartTotalInPounds >= minCheckoutAmount;

        if(meetsMinimum){
            cartCheckoutBtn.removeAttribute('disabled');
            cartCheckoutBtn.value = `Proceed to Checkout`;
            cartCheckoutBtn.innerHTML = `Proceed to Checkout`;
        }else{
            cartCheckoutBtn.setAttribute('disabled', 'disabled');
            cartCheckoutBtn.value = `MINIMUM SPEND OF £${minCheckoutAmount} WHEN PLACING AN ORDER`;
            cartCheckoutBtn.innerHTML = `MINIMUM SPEND OF £${minCheckoutAmount} WHEN PLACING AN ORDER`;
        }
    }

    /**
     * Setup the cart drawer.
     */
    const setupDrawer = async () => {
        
        const cart = await fetchCart();
        if(cart.item_count === 0){
            setCartEmptyState();
            cartDrawer.querySelector('#loading-overlay').classList.add('hide-important');
            return;
        }else{
            cartDrawer.classList.remove('is-empty');
            emptyContent[0].classList.add('hide-important');
            setVisibility(drawerWrapper, 'show');
        }
        const data = await (await fetch(window.location.pathname + "?sections=cart-drawer-items")).json();
        document.querySelector('.shopify-section').innerHTML = data["cart-drawer-items"];
        document.getElementById('cart_sub_total').innerHTML = `£${(cart.total_price / 100).toFixed(2)}`;
        attachEventListeners();
        setCheckoutButton(cart.total_price);
        fetchRecommendedProducts(cart.items[0].product_id);
    }

    /**
     * Fetch the cart
     * @returns {Promise} The cart.
     */
    const fetchCart = async () => {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) throw new Error('Failed to fetch the cart.');

            return await response.json();
        } catch (error) {
            cartErrors.textContent = 'An error occurred while fetching the cart.';
        }
    }

    /**
     * Set cart Empty state.
     */
    const setCartEmptyState = () => {
        cartDrawer.classList.add('is-empty');
        emptyContent[0].classList.remove('hide-important');
        setVisibility(drawerWrapper, 'hide');
        document.getElementById('EmptyCartDrawer-close').addEventListener('click', closeCartDrawer);
        document.getElementById('EmptyCartDrawer-ContinueShopping').addEventListener('click', closeCartDrawer);
    }

    /**
     * Change the visibility of all childern in a div element except first.
     * @param {HTMLElement} element - The element to toggle.
     * @param {string} action - The add hide class or tp remove.
     */
    const setVisibility = (element, action) => {
        const children = element.children;
        for (let i = 1; i < children.length; i++) {
            if(action === 'hide'){
                children[i].classList.add('hide-important');
            }else{
                children[i].classList.remove('hide-important');
            }
        }
    }


    /**
     * Attach event listeners to the cart items.
     */
    const attachEventListeners = () => {
        const cartItems = document.querySelectorAll('.drawer-cart-item');
        cartItems.forEach(cartItem => {
            cartItem.querySelectorAll('button').forEach(button => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    cartItem.querySelector('.product-price-snippet').classList.add('hide-important');
                    cartItem.querySelector('.price-loader').classList.remove('hide-important');
                    if(button.classList.contains('remove-btn')){
                        if(event.pointerType === ''){
                            return;
                        }
                        if(button.getAttribute('data-id') != null && button.getAttribute('data-id') != undefined){
                            cartCheckoutBtn.setAttribute('disabled', 'disabled');
                            const hamperId = button.getAttribute('data-id');
                            let hamperChilderns = button.getAttribute('data-childrens');
                            hamperChilderns = hamperChilderns.split(',');
                            removeHamper(hamperChilderns, hamperId);
                        }else{
                            const lineitem = button.getAttribute('data-line-index');
                            cartCheckoutBtn.setAttribute('disabled', 'disabled');
                            changeCart(lineitem, 0).then((cart) => {
                                if(!cart) return;
                                if(cart.item_count === 0){
                                    setCartEmptyState();
                                    return;
                                }
                                document.querySelector('.shopify-section').innerHTML = cart.sections["cart-drawer-items"];
                                document.getElementById('cart_sub_total').innerHTML = `£${(cart.total_price / 100).toFixed(2)}`;
                                attachEventListeners();
                                setCheckoutButton(cart.total_price);
                            });
                        }
                    }else{
                        const lineitem = button.getAttribute('data-line-index');
                        const action = button.getAttribute('data-action');
                        let currentvalue = parseInt(cartItem.querySelector('input').value)
                        if(action === 'dec' && currentvalue === 1){
                            cartItem.querySelector('.price-loader').classList.add('hide-important');
                            cartItem.querySelector('.product-price-snippet').classList.remove('hide-important');
                            return;
                        }
                        let updatedValue = action === 'inc' ? currentvalue + 1 : currentvalue - 1;
                        cartItem.querySelector('input').value = updatedValue;
                        cartCheckoutBtn.setAttribute('disabled', 'disabled');
                        changeCart(lineitem, updatedValue).then((cart) => {
                            if(!cart) return;
                            document.querySelector('.shopify-section').innerHTML = cart.sections["cart-drawer-items"];
                            document.getElementById('cart_sub_total').innerHTML = `£${(cart.total_price / 100).toFixed(2)}`;
                            attachEventListeners();
                            setCheckoutButton(cart.total_price);
                        });
                    }
                });
            });
            if(cartItem.querySelector('input') !== null){
                cartItem.querySelector('input').addEventListener('focusin', (event) => {
                    event.preventDefault();
                    cartItem.querySelector('input').setAttribute('data-prev-value', cartItem.querySelector('input').value);
                });
                cartItem.querySelector('input').addEventListener('change', (event) => {
                    event.preventDefault();
                    cartItem.querySelector('.product-price-snippet').classList.add('hide-important');
                    cartItem.querySelector('.price-loader').classList.remove('hide-important');
                    const lineitem = cartItem.querySelector('input').getAttribute('data-line-index');
                    const quantity = parseInt(cartItem.querySelector('input').value);
                    if(quantity <= 0  || quantity === '' || isNaN(quantity)){
                        cartItem.querySelector('input').value = cartItem.querySelector('input').getAttribute('data-prev-value');
                        cartItem.querySelector('.price-loader').classList.add('hide-important');
                        cartItem.querySelector('.product-price-snippet').classList.remove('hide-important');
                        return;
                    }
                    cartCheckoutBtn.setAttribute('disabled', 'disabled');
                    changeCart(lineitem, quantity).then((cart) => {
                        if(!cart) return;
                        document.querySelector('.shopify-section').innerHTML = cart.sections["cart-drawer-items"];
                        document.getElementById('cart_sub_total').innerHTML = `£${(cart.total_price / 100).toFixed(2)}`;
                        attachEventListeners();
                        setCheckoutButton(cart.total_price);
                    });
                });
            }
        });
    }

    /**
     * Updates the cart drawer with the given items and total price.
     * 
     * @param {number} line 
     * @param {number} quantity 
     * @returns 
     */
    const changeCart = async (line, quantity) => {
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line, quantity, sections: ['cart-drawer-items'], sections_url: window.location.pathname }),
            });

            const data = await response.json();

            if (!response.ok) {
                if (response.status === 422 && data.message && data.message.endsWith('sold out.')) {
                    alert(`${data.message} It is removed from your cart.`);
                }
                return null;
            }

            return data;
        } catch (error) {
            cartErrors.textContent = 'An error occurred while updating the cart.';
            return null;
        }
    }

    /**
     * Remove Hamper from cart.
     */
    const removeHamper = async (hamperChildern, hamperId) => {
        let updates = {};
        for(let i = 0; i < hamperChildern.length; i++){
            updates[hamperChildern[i]] = 0;
        }
        updates[hamperId] = 0;
        const data = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates, sections: ['cart-drawer-items'], sections_url: window.location.pathname }),
        })
        if (!data.ok) {
            throw new Error('Failed to update the cart.');
        }
        const cart = await data.json();

        if(cart.item_count === 0){
            setCartEmptyState();
            return;
        }
        document.querySelector('.shopify-section').innerHTML = cart.sections["cart-drawer-items"];
        document.getElementById('cart_sub_total').innerHTML = `£${(cart.total_price / 100).toFixed(2)}`;
        attachEventListeners();
        setCheckoutButton(cart.total_price);
    }

    /**
     * Closes the cart drawer.
     */
    const closeCartDrawer = () => {
        cartDrawer.classList.remove('active');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');
    };

    /**
     * Fetch and render recommended products for the interesting product.
     * 
     * @param {productId} interestingProductId - The interesting product from cart.
     * @param {number} limit - The number of recommended products to fetch.
     */
    const fetchRecommendedProducts = (interestingProductId, limit = 2) => {
        fetch(`/recommendations/products.json?product_id=${interestingProductId}&limit=${limit}`).then((response) => {
            response.json().then((data) => {
                if(data.products.length === 0){
                    document.getElementById('CartDrawer-Recommendations').classList.add('hide-important');
                    return;
                }else if(data.products.length >= 1 && document.getElementById('CartDrawer-Recommendations')?.classList.contains('hide-important')){
                    document.getElementById('CartDrawer-Recommendations').classList.remove('hide-important');
                }
                let recommendedProducts = '';
                data.products.forEach((product) => {
                    recommendedProducts += `
                    <div class="cart-recommended-item">
                        <div class="cart-recommended-item__media">
                        <a href="${product.url}" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a>
                        <img
                            class="cart-recommended-item__image"
                            src="${product.featured_image}"
                            alt="${product.title}"
                            loading="lazy"
                            width="100"
                            height="150"
                        >
                        </div>
                        <div class="cart-recommended-item-details">
                        <h5 class="heading-6">
                            <a href="${product.url}">
                            ${product.title}
                            </a>
                        </h5>
                        <p>
                            £${(product.price / 100).toFixed(2)}
                        </p>
                        <button class="btn btn--primary btn-add-to-cart" data-product-id="${product.id}" data-varient-id="${product.variants != undefined ? product.variants[0].id: undefined}">Add to Bag</button>
                        </div>
                    </div>
                    `;
                });
                document.getElementById('Recommended__Products').innerHTML = recommendedProducts;
                document.querySelectorAll('.btn-add-to-cart').forEach((button) => {
                    button.addEventListener('click', addToCartFromRecommended);
                });
            });
        });
    }

    /**
     * Add to cart from recommended products.
     * 
     * @param {Event} event - The event object.
     */
    const addToCartFromRecommended = async (event) => {
        cartDrawer.querySelector('#loading-overlay').classList.remove('hide-important');
        event.preventDefault();
        const productId = event.target.dataset.productId;
        const varientId = event.target.dataset.varientId;
        const product = varientId !== "undefined" ? varientId : productId;
        const quantity = 1;
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: product, quantity }),
            });
            if (!response.ok) throw new Error('Failed to add the product to the cart.');
        
            await setupDrawer();
            cartDrawer.querySelector('#loading-overlay').classList.add('hide-important');
        } catch (error) {
            console.error(error);
            cartErrors.textContent = 'An error occurred while adding the product to the cart.';
            cartDrawer.querySelector('#loading-overlay').classList.add('hide-important');
        }
    }

    // Event listeners
    cartOverlay.addEventListener('click', closeCartDrawer);
    document.getElementById('drawer__close').addEventListener('click', closeCartDrawer);
    document.getElementById('CartDrawer-ContinueShopping').addEventListener('click', closeCartDrawer);

    if (cartIcon) {
        cartIcon.setAttribute('role', 'button');
        cartIcon.setAttribute('aria-haspopup', 'dialog');
        cartIcon.addEventListener('click', openCartDrawer);
    }

    // Initial setup
    cartDrawer.setAttribute('aria-hidden', 'true');

    // Listen to item added to cart via blubot event
    window.addEventListener('blubolt:add-to-cart', event => { 
        openCartDrawer(); 
    });

    // Additional listener for cart updates to re-validate button state
    window.addEventListener('cart:updated', event => {
        if (cartDrawer.classList.contains('active')) {
            // Re-fetch cart and update button if drawer is open
            fetchCart().then(cart => {
                if (cart && cart.total_price !== undefined) {
                    setCheckoutButton(cart.total_price);
                }
            });
        }
    });
});